import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SliderCommunityComponent } from './slider-community/slider-community.component';
import { MatCardModule } from '@angular/material/card';

@NgModule({
	declarations: [SliderCommunityComponent],
	imports: [CommonModule, MatCardModule],
	exports: [SliderCommunityComponent]
})
export class SliderCommunityModule {}
